module.exports = __webpack_public_path__ + "static/media/google.ffe5e6be.svg";


//////////////////
// WEBPACK FOOTER
// ./src/google.svg
// module id = 101
// module chunks = 0